import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { AttachService } from '@app/shared/attach/attach.service';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { DomSanitizer,SafeHtml, SafeResourceUrl } from '@angular/platform-browser';



import * as common from '@app/shared/_models/common';

@Component({
  selector: 'app-image-viewer-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule],
  templateUrl: './image-viewer-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./image-viewer-dialog.component.scss']
})
export class ImageViewerDialogComponent implements OnInit {
  contentLocalUrl: string = '';
  imageName: string = '';
  loadingState: number = 0 ;   // 0 loadiing  1 ok requette ok   -1 erreur de la requette image non dispo ....
  isYoutubeVideo = false;
  youtubeEmbedUrl: SafeResourceUrl | null = null;

  constructor( public dialogRef: MatDialogRef<ImageViewerDialogComponent>, private attachService:AttachService, private sanitizer: DomSanitizer ,
    @Inject(MAT_DIALOG_DATA) public data: { attach: common.Attach } , 
  ) {}

  ngOnInit(): void {

    if (this.data?.attach) {
      this.loadingState = 0;
      this.imageName = this.data.attach.name || 'Image';

      // Détection vidéo YouTube
      if (this.data.attach.contenttype?.startsWith("video/youtube")) {
        this.isYoutubeVideo = true;
        const embedUrl = this.extractEmbedUrl();
        if (embedUrl) {
          this.youtubeEmbedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
        }
        return; // Pas besoin de charger l'image
      }

      // Chargement image
      let temp_subscription = this.attachService.loadImage$(this.data.attach.id??0).subscribe({
        next: (blob) => {
          console.log('Salut from : dans le next');
          // --- CAS DE SUCCÈS ---
          this.contentLocalUrl = URL.createObjectURL(blob);
          this.data.attach.contentLocalUrl = this.contentLocalUrl;
          this.loadingState = 1; // État "chargé"
        },
        error: (err: any) => {
          // --- CAS D'ERREUR ---
          console.error('Erreur lors du chargement de l\'image', err);
          this.loadingState = -1; // Par exemple : État "erreur" pour l'UI
          // Vous pouvez inspecter l'erreur
          if (err.status === 404) {
            console.log('Image non trouvée');
          }
        },
        });

    }


    // this.attachs_images.forEach((attach_image : common.Attach ,index : number ) =>{
    //   if(attach_image.thumbnailLocalUrl){ return; }
    //   })




  }

    private extractEmbedUrl(): string | null {
    // Méthode 1 : Extraire depuis le HTML de l'API
    if (this.data.attach.data?.['html']) {
      const match = this.data.attach.data['html'].match(/src="([^"]+)"/);
      if (match) {
        return match[1].split('?')[0]; // URL propre sans query params
      }
    }
    // Méthode 2 : Construire depuis l'URL youtu.be
    if (this.data.attach.data?.['url']) {
      const id = this.extractYoutubeId(this.data.attach.data['url']);
      if (id) {
        return `https://www.youtube.com/embed/${id}`;
      }
    }
    return null;
  }
    private extractYoutubeId(url: string): string | null {
    const match = url.match(/(?:youtu\.be\/|youtube\.com\/watch\?v=)([^&?/]+)/);
    return match ? match[1] : null;
  }

  onImageError(): void {
    this.loadingState = -1;
    console.error('Erreur lors du chargement de l\'image');
  }

  close(): void {
    this.dialogRef.close();
  }
}

